export default {
  '·': '·',
  dot: '·',
  middot: '·',
  '•': ' • ',
  ',': ',',
  '=': '=',
  '1/2': '1⁄2',
  '1/3': '1⁄3',
  '2/3': '2⁄3',
  '1/4': '1⁄4',
  '3/4': '3⁄4',
  '–': '–',
  ndash: '–',
  'en dash': '–',
  'spaced ndash': ' – ',
  '—': '—',
  mdash: '—',
  spd: ' – ',
  'em dash': '—',
  'number sign': '#',
  'hash-tag': '#',
  ibeam: 'I',
  '&': '&',
  ';': ';',
  ampersand: '&',
  'dagger': '†',
  'double-dagger': '‡',
  snds: ' – ',
  snd: ' – ',
  '^': ' ',
  '!': '|',
  "'": `'`,
  '\\': ' /',
  '`': '`',
  bracket: '[',
  '[': '[',
  '*': '*',
  asterisk: '*',
  'long dash': '———',
  clear: '\n\n',
  'h.': 'ḥ',
  profit: '▲',
  loss: '▼',
  gain: '▲',
  ell: 'ℓ',
  '1~': '~',
  '2~': '~~',
  '3~': '~~~',
  '4~': '~~~~',
  '5~': '~~~~~',
  // some emoji replacements
  goldmedal: '🥇',
  silvermedal: '🥈',
  bronzemedal: '🥉',
  done: '✅',
  xmark: '❌',
  checked: '✔️',
  'thumbs up': '👍',
  'thumbs down': '👎',
}
